module.exports = __webpack_public_path__ + "img/nolan-report-card.6a141b14.svg";